<mat-card appearance="outlined" *ngIf="fetchingError">
  <mat-card-content class="row">
    <mat-icon class="no-flex">error</mat-icon>
    <span>Error fetching diagnostics.</span>
  </mat-card-content>
</mat-card>

<div class="loading-bar">
  <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
</div>

<div *ngIf="diagnostics$ | async as diagnostics" class="table-scroll">
  <table mat-table [dataSource]="diagnostics" class="mat-elevation-z8" *ngIf="!loading && !fetchingError">
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef>Created At</th>
      <td mat-cell *matCellDef="let diagnostic">{{diagnostic.createdAt | date:'medium'}}</td>
    </ng-container>

    <ng-container matColumnDef="filename">
      <th mat-header-cell *matHeaderCellDef>Filename</th>
      <td mat-cell *matCellDef="let diagnostic">{{diagnostic.filename ?? 'N/A'}}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let diagnostic">{{diagnostic.status}}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let diagnostic">
        <button mat-icon-button matTooltip="Download diagnostic" [disabled]="diagnostic.status !== 'UPLOADED'" (click)="downloadDiagnostic(diagnostic)">
          <mat-icon>download</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['createdAt', 'filename', 'status', 'actions']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['createdAt', 'filename', 'status', 'actions'];"></tr>
  </table>
</div>